import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

export const _User = {
    getGiftCardToRedeem: (secret_key) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url('/users/gift-cards/redeem/get-to-redeem'),
            {
                secret_key: secret_key,
                token: AuthAPI.getUserAccessToken(),
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    redeem: function (secret_key) {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url('/users/gift-cards/redeem'),
            {
                secret_key: secret_key,
                token: AuthAPI.getUserAccessToken(),
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    }
}
